/**
 * Logout-Intent: verhindert Wiederherstellung der Business-Session nach Déconnexion.
 * KV-Key überlebt Reload; Session-Key blockiert In-Flight-Races vor Reload.
 */

import { kvGet, kvSetPersisted, kvRemove } from '../infrastructure/storage/kvAccess';
import { sessionGet, sessionSet, sessionRemove } from '../infrastructure/storage/sessionAccess';

export const BUSINESS_LOGOUT_LS_KEY = 'aman_business_logout_at';
export const BUSINESS_LOGOUT_SS_KEY = 'aman_business_logout';

export function markBusinessLogoutIntent() {
  try {
    sessionSet(BUSINESS_LOGOUT_SS_KEY, '1');
    void kvSetPersisted(BUSINESS_LOGOUT_LS_KEY, String(Date.now()));
  } catch (_) {
    /* ignore */
  }
}

export function isBusinessLogoutInProgress() {
  try {
    return Boolean(sessionGet(BUSINESS_LOGOUT_SS_KEY) || kvGet(BUSINESS_LOGOUT_LS_KEY));
  } catch (_) {
    return false;
  }
}

/** Liest und entfernt Logout-Intent (beim App-Start nach Reload). */
export function consumeBusinessLogoutIntent() {
  try {
    const had = isBusinessLogoutInProgress();
    sessionRemove(BUSINESS_LOGOUT_SS_KEY);
    kvRemove(BUSINESS_LOGOUT_LS_KEY);
    return had;
  } catch (_) {
    return false;
  }
}

export function clearBusinessLogoutIntent() {
  try {
    sessionRemove(BUSINESS_LOGOUT_SS_KEY);
    kvRemove(BUSINESS_LOGOUT_LS_KEY);
  } catch (_) {
    /* ignore */
  }
}
